import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
    selector: 'esp-discovery-toolbar',
    templateUrl: './discovery-toolbar.component.html',
    styleUrls: ['./discovery-toolbar.component.scss'],
    host: { 'class': 'esp-discovery-toolbar' },
    standalone: true
})
export class DiscoveryToolbarComponent implements OnInit {

    // TODO: Skipped for migration because:
    //  This input is used in combination with `@HostBinding` and migrating would
    //  break.
    @HostBinding('class.has-shadow') @Input() shadow = false;

    constructor() { }

    ngOnInit() {
    }

}
